import React from 'react';
export function Footer() {
  return <footer className="bg-[#04203B] px-4 py-4 text-center text-[10px] font-medium leading-snug text-white/60 sm:px-6 sm:text-[11px]" data-id="element-61" data-mp="32wd2qgad7ltj">
      <p className="mb-1 font-extrabold uppercase text-white/80" data-id="element-62" data-mp="32num8qaq072f">
        © 2026 Pickleball Coach Pro™ — All Rights Reserved.
      </p>
      <p className="mx-auto mb-2 max-w-xl" data-id="element-63" data-mp="36qhhl16loa4d">
        This training system is provided for educational and professional development purposes and
        is designed to support pickleball coaches with practical drills, progressions, session
        structures, player development programs, and coaching resources. Coaches remain responsible
        for adapting activities to each player's ability, physical condition, training environment,
        and applicable safety requirements.
      </p>
      <nav aria-label="Legal links" className="mb-1 flex justify-center gap-2 font-bold" data-id="element-64" data-mp="29yxcjbkkrila">
        <a href="#" className="hover:text-brand-green" data-id="element-65" data-mp="2eyt8qon165qa">
          Terms &amp; Conditions
        </a>
        <span data-id="element-66" data-mp="3l90ozzfy550u">•</span>
        <a href="#" className="hover:text-brand-green" data-id="element-67" data-mp="3labovo69tsmo">
          Privacy Policy
        </a>
        <span data-id="element-68" data-mp="3gbimaqsivm1a">•</span>
        <a href="#" className="hover:text-brand-green" data-id="element-69" data-mp="3gc0jbpn0e4a9">
          Contact
        </a>
      </nav>
      <p data-id="element-70" data-mp="3v9azvdeie0cu">
        Support:{' '}
        <a href="mailto:kitonline27@gmail.com" className="font-bold hover:text-brand-green" data-id="element-71" data-mp="3q8mzw28ay96h">
          kitonline27@gmail.com
        </a>
      </p>
    </footer>;
}